const sizes = {
  tiny: 'w-3 h-3',
  small: 'w-4 h-4',
  medium: 'w-6 h-6',
  large: 'w-8 h-8'
}

const WebsiteFavicon = ({
  url,
  fallbackText,
  size = 'small',
  className,
}: {
  url?: string
  fallbackText?: string
  size?: 'tiny' | 'small' | 'medium' | 'large'
  /** Additional class names forwarded to the rendered <img> (or fallback <div>).
   *  Use e.g. className="!opacity-100" to override the default opacity-70
   *  when the icon should appear at full opacity (e.g. a resolved provider icon). */
  className?: string
}) => {
  if (!url) {
    return (
      <div className={`${sizes[size]} rounded-md bg-slate-200 dark:bg-slate-700 flex items-center justify-center text-xs font-medium text-slate-400 ${className ?? ''}`}>
        {fallbackText?.toUpperCase().slice(0, 1)}
      </div>
    );
  }

  const domain = url.replace('https://', '').replace('http://', '').replace('www.', '');

  return (
    <img
      src={`https://www.google.com/s2/favicons?domain=${domain}&sz=256`}
      alt=""
      className={`${sizes[size]} opacity-70 ${className ?? ''}`}
      onError={(e) => {
        (e.target as HTMLImageElement).style.display = 'none';
      }}
    />
  )
}

export default WebsiteFavicon;
